import { useEffect, useRef, useState } from 'react';
import api from '../api';

const POLL_MS = 30_000;

/** Очередь CRM для бейджей: заказы pending + заявки на замер requested. */
export function useAdminPendingQueueCounts(enabled: boolean) {
  const [pendingOrdersCount, setPendingOrdersCount] = useState(0);
  const [pendingMeasurementsCount, setPendingMeasurementsCount] = useState(0);

  useEffect(() => {
    if (!enabled) {
      setPendingOrdersCount(0);
      setPendingMeasurementsCount(0);
      return;
    }
    let stopped = false;
    const poll = async () => {
      try {
        const [ordersRes, measurementsRes] = await Promise.all([
          api.get('/admin/orders', { params: { status: 'pending', limit: 200 } }),
          api.get('/admin/measurements', { params: { limit: 400 } }),
        ]);
        const orders = Array.isArray(ordersRes.data) ? ordersRes.data.length : 0;
        const measurements = Array.isArray(measurementsRes.data)
          ? measurementsRes.data.filter((m: { status?: string }) => m.status === 'requested').length
          : 0;
        if (!stopped) {
          setPendingOrdersCount(orders);
          setPendingMeasurementsCount(measurements);
        }
      } catch {
        if (!stopped) {
          setPendingOrdersCount(0);
          setPendingMeasurementsCount(0);
        }
      }
    };
    void poll();
    const id = window.setInterval(() => void poll(), POLL_MS);
    return () => {
      stopped = true;
      window.clearInterval(id);
    };
  }, [enabled]);

  const pendingTotal = pendingOrdersCount + pendingMeasurementsCount;
  return { pendingOrdersCount, pendingMeasurementsCount, pendingTotal };
}

/** Haptic when pending total grows (first poll excluded). */
export function useAdminPendingHaptic(
  pendingTotal: number,
  enabled: boolean,
  haptic: { impact: (style: 'light' | 'medium' | 'heavy') => void },
) {
  const prevRef = useRef(0);
  useEffect(() => {
    if (!enabled) return;
    if (prevRef.current > 0 && pendingTotal > prevRef.current) {
      haptic.impact('medium');
    }
    prevRef.current = pendingTotal;
  }, [pendingTotal, enabled, haptic]);
}
